<template>
  <div>
    <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" icon @click="refreshStorage()" small>
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-toolbar>
    <v-form-card
      :dObject="data_object"
      v-bind="schema['v-bind']"
      ref="form"
      :panels="true"
      :key="formKey"
      :submit_button_caption="submitCaption"
      :actionFixedPosition="true"
    ></v-form-card>
  </div>
</template>

<script>
import * as fun from "../plugins/common";

import axios from "axios";
export default {
  name: "StorageDetail",
  components: {
    VFormCard: () => import("../components/FormCard.vue"),
  },

  data() {
    return {
      schema: null,
      data_object: null,
      sid: "",
      submitCaption: "Save",
    };
  },
  mounted() {
    var that = this;
    this.refreshStorage();
    this.$root.$on("tableChanged", (tbl, keys) => {
      // console.log(tbl);
      if (tbl.tableName == "inventory") {
        that.model.inventory = tbl.originalRecords;
        that.calculateInventoryVolume();
      }
    });
  },
  beforeDestroy() {},
  methods: {
    refreshData() {
      var that = this;
      axios
        .post(this.serverURL + "/get_data", this.data, {
          withCredentials: true,
        })
        .then((response) => {
          that.data_object = response.data;
          var calcInventory;
          if (!that.data_object.model._id) {
            that.data_object.model = {};
            calcInventory = true;
          }

          if (
            response.data.additional_model &&
            response.data.additional_model.shipment
          ) {
            that.data_object.model.customer =
              response.data.additional_model.customer[0];
            that.data_object.model.inventory =
              response.data.additional_model.shipment[0].inventory;
          }
          // this.data_object.model = response.data.model[0];
          this.data_object.object_name = "storage";
          this.schema = response.data.schema;
          this.formKey = !this.formKey;
          if (calcInventory) {
            this.calculateInventoryVolume();
          }
          // if (!this.model._id) {
          //   this.addDefaultData(this.data_object);
          // } else {
          //   var model = this.data_object.model;
          //   this.addMissingPropertis(model);
          // }
        });
    },

    refreshStorage(reload) {
      this.storage_id = this.$route.params.id.toString().split(":")[0];
      this.data = {
        object_name: "storage",
        single_record: true,
        qry: {
          storage_id: parseInt(this.storage_id),
        },
        portal_id: this.$session.get("portal_id"),
      };
      this.sid = this.$route.params.id.toString().split(":")[1];
      if (this.sid) {
        var customerId = this.$route.params.id.toString().split(":")[2];
        this.data.additional_data = [
          {
            obj_name: "shipment",
            qry: { _id: this.sid },
            fields: ["inventory"],
          },

          {
            obj_name: "customer",
            qry: {
              _id: customerId,
            },
          },
        ];
      }

      this.refreshData(reload);
    },
    calculateInventoryVolume() {
      var inventory = this.data_object.model.inventory;
      if (!inventory) {
        inventory = [];
      }
      // that.data_object.model.inventory_volume = 0;
      var inventory_volume = 0;
      if (inventory && inventory.length) {
        inventory.forEach((i) => {
          if (i.volume && i.qty) {
            inventory_volume += parseFloat(i.volume) * parseInt(i.qty);
          }
        });
        this.data_object.model.storage_size = inventory_volume;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
